import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-cnh',
  templateUrl: './consulta-cnh.component.html',
  styleUrls: ['./consulta-cnh.component.scss']
})
export class ConsultaCnhComponent implements OnInit {


  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  exames: any;
  registrosBloqueados: any;
  registrosBloqueadosLiberacao: any;
  cursos: any;
  pontuacao: any;
  observacoes: any;

  @Input() token = '';

  constructor() {}

  ngOnInit() {
    this.setRegistrosExame();
    this.setRegistrosBloqueio();
    this.registrosBloqueioLiberacao();
    this.setRegistrosCursos();
    this.setPontuacao();
    this.setObservacoes();
  }

  ngOnChanges() {}

  setRegistrosBloqueio() {
    this.registrosBloqueados = this.consulta.registrosBloqueio;
  }

  registrosBloqueioLiberacao() {
    this.registrosBloqueadosLiberacao = this.consulta.registrosBloqueioLiberacao;
  }

  setRegistrosExame() {
    this.exames = this.consulta.registrosExames;
  }

  setRegistrosCursos() {
    this.cursos = this.consulta.registrosCursos;
  }

  setPontuacao() {
    this.pontuacao = this.consulta.pontuacao;
  }

  setObservacoes() {
    this.observacoes = this.consulta.Observacoes;
  }
}
